import { render } from "./Decoration.vue?vue&type=template&id=7a0dfb02&scoped=true"
import script from "./Decoration.vue?vue&type=script&lang=js"
export * from "./Decoration.vue?vue&type=script&lang=js"

import "./Decoration.vue?vue&type=style&index=0&id=7a0dfb02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0dfb02"]])

export default __exports__